import React from 'react';
import {useHistory, useParams, withRouter} from "react-router-dom";
import Button from "react-bootstrap/Button";
import MySwal from "sweetalert2";
import {contactPlayers} from "../../services/matches";
import {NotificationManager} from "react-notifications";
import {useTranslation} from "react-i18next";

// React Components
import GameCard from "../../components/GameCard";
import Header from "../../components/Header";

// CSS Files
import './styles.css';

const PlayerContacts = (props) => {
   const history = useHistory();
   const { t } = useTranslation();
   const { matchId } = useParams();

   return (
      <>
         <Header
            headerBarTitle={t("to_schedule_page.header")}
            showHeaderExtras
            showBackButton
            headerLight>
         </Header>
         <div className={"contacts-wrapper mt-4"}>
            <GameCard contacts gameInfo={props.location.state}/>
            <Button
               className="w-100 btn-thick mt-3 mb-2"
               variant={"primary"}
               onClick={() => {
                  MySwal.fire({
                     customClass: {
                        container: 'app-wrapper',
                        input: 'cancel-popup-input',
                        actions: 'cancel-popup-actions',
                     },
                     titleText: t("to_schedule_page.contact_players"),
                     text: t("to_schedule_page.insert_availability"),
                     html: `<textarea id="contact-message" class="cancel-popup-input d-flex swal2-textarea" placeholder=${t("to_schedule_page.proposal")}></textarea> <p class="mt-4">${t("to_schedule_page.contact_players_alert")}</p>`,
                     showCancelButton: true,
                     cancelButtonText: t("common.close"),
                     confirmButtonText: t("common.send"),
                     allowEscapeKey: false,
                     preConfirm: () => {
                        let message = document.getElementById('contact-message').value;

                        if (message === "") {
                           NotificationManager.error(t("to_schedule_page.errors.proposal_mandatory"), t("common.error"), 4000);
                           return false;
                        }
                     }
                  }).then(async (res) => {
                     if (res.dismiss === MySwal.DismissReason.cancel) {
                        MySwal.close();
                     } else {
                        try {
                           await contactPlayers(matchId, document.getElementById('contact-message').value);
                           MySwal.fire({
                              text: t("to_schedule_page.message_sent"),
                              allowOutsideClick: false
                           }).then(() => {
                              history.push("/my-games");
                           })
                        } catch (e) {
                           NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
                        }
                     }
                  })
               }}>
               {t("to_schedule_page.contact_players")}
            </Button>
         </div>
      </>
   )
}

export default withRouter(PlayerContacts);
